import MinimumValueErrorLabel from '../labels/MinimumValueErrorLabel';
import { useSelector } from 'react-redux';
import useDeliveryThreshold from '../../hooks/order/useDeliveryThreshold';
import { useTranslation } from 'react-i18next';
import { StoreInterface } from '../../store/types';
import useAppMethods from '../../hooks/utility/useAppMethods';

interface Props {
  className?: string;
}

export default function DeliveryThreshold(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Delivery:DeliveryThreshold' });

  const { className } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { formatCurrency } = useAppMethods();
  const {
    hasDeliveryThreshold,
    isWithinThreshold,
    isWithinMinThreshold,
    isWithinMaxThreshold,
    minThreshold,
    maxThreshold,
    amountTillMinThreshold,
  } = useDeliveryThreshold();

  return (
    hasDeliveryThreshold &&
    !isWithinThreshold && (
      <>
        {!isWithinMinThreshold && (
          <div className={className} data-test="delivery-min-threshold-notice">
            <MinimumValueErrorLabel
              description={t('min.title')}
              value={formatCurrency(amountTillMinThreshold)}
              type="Notice"
            />
            <p className="mt-xs text-xs">
              {t('min.description', {
                name: company?.name,
                threshold: formatCurrency(minThreshold),
              })}
            </p>
          </div>
        )}
        {!isWithinMaxThreshold && (
          <div className={className}>
            <MinimumValueErrorLabel description={t('max.title')} type="Warning" />
            <p className="mt-xs text-xs">
              {t('max.description', {
                name: company?.name,
                threshold: formatCurrency(maxThreshold),
              })}
            </p>
          </div>
        )}
      </>
    )
  );
}
